enum AssetNomenclatureFieldNames {
  ComponentAsset = 'componentAsset',
  ComponentAssetText = 'componentAssetText',
  MainAsset = 'mainAsset',
  Quantity = 'quantity',
}

export default AssetNomenclatureFieldNames;
